import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="about" className="py-24 bg-white overflow-hidden" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-12">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-13">
            <div className="flex items-center gap-3 mb-6" data-id="element-14">
              <span className="text-primary text-xs font-bold tracking-widest uppercase" data-id="element-15">
                About Us
              </span>
              <div className="h-[1px] w-12 bg-border" data-id="element-16" />
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-8 leading-tight" data-id="element-17">
              Building Lasting Partnerships Since 2003
            </h2>

            <div className="space-y-6 text-lg text-body leading-relaxed" data-id="element-18">
              <p data-id="element-19">
                At Kingsbury Maintenance & Construction, our goal is to enable
                your business to deliver the high standards demanded in today's
                competitive market.
              </p>
              <p data-id="element-20">
                With over 20 years of experience, we build lasting partnerships
                through expert consultation, maintenance, and construction
                services. We ensure your facilities remain productive and
                aligned with modern business needs.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-8 pt-8 border-t border-border" data-id="element-21">
              <div data-id="element-22">
                <p className="text-4xl font-bold text-charcoal mb-2" data-id="element-23">20+</p>
                <p className="text-sm text-body font-medium uppercase tracking-wider" data-id="element-24">
                  Years Experience
                </p>
              </div>
              <div data-id="element-25">
                <p className="text-4xl font-bold text-charcoal mb-2" data-id="element-26">100%</p>
                <p className="text-sm text-body font-medium uppercase tracking-wider" data-id="element-27">
                  Commitment
                </p>
              </div>
            </div>
          </motion.div>

          {/* CEO Image & Bio */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1],
          delay: 0.2
        }} className="relative" data-id="element-28">
            <div className="absolute -inset-4 bg-warm-grey rounded-2xl transform rotate-3 -z-10" data-id="element-29" />
            <div className="relative rounded-lg overflow-hidden shadow-xl" data-id="element-30">
              <img src="https://cdn.magicpatterns.com/uploads/s6dViDHAnDRz92SR6DBzAu/WhatsApp_Image_2026-03-20_at_08.26.12_(1).jpg" alt="Dencell Green, CEO & Founder of Kingsbury Maintenance & Construction" className="w-full h-auto object-cover aspect-[4/5] md:aspect-square lg:aspect-[4/5]" data-id="element-31" />
              <div className="absolute inset-0 ring-1 ring-inset ring-black/10 rounded-lg" data-id="element-32" />
            </div>

            {/* CEO Info Card */}
            <div className="absolute -bottom-6 left-4 right-4 bg-white rounded-lg shadow-lg p-5 border border-border/50" data-id="element-33">
              <h3 className="text-lg font-bold text-charcoal" data-id="element-34">Dencell Green</h3>
              <p className="text-primary text-sm font-semibold mb-2" data-id="element-35">
                CEO & Founder
              </p>
              <p className="text-sm text-body leading-relaxed" data-id="element-36">
                With over 20 years of experience, Dencell leads Kingsbury
                Maintenance & Construction with a commitment to quality,
                integrity, accountability and lasting client relationships.
              </p>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-primary/10 rounded-full blur-2xl -z-10" data-id="element-37" />
          </motion.div>
        </div>
      </div>
    </section>;
}